import { BaseContainerModel } from '../../base-container.model';
import { bl_fi_mst_item_attribute_child_link_RowClass } from '../../../dbschema/bl_fi_mst_item_attribute_child_link.model';
import { bl_fi_mst_attribute_set_hdr_RowClass } from '../../../dbschema';
import * as fromDatatype from '../../../datatype-library/index';

export class ItemAttributeChildLinkListingContainerModel extends BaseContainerModel {
  fi_item_hdr_guid: fromDatatype.GuidDataFieldInterface;
  bl_fi_mst_item_attribute_child_link: bl_fi_mst_item_attribute_child_link_RowClass = new bl_fi_mst_item_attribute_child_link_RowClass();
  bl_fi_mst_attribute_set_hdrs: bl_fi_mst_attribute_set_hdr_RowClass[] = [];
}